export default import.meta.ROLLDOWN_FILE_URL_T6klPqL5HaqCH5EiYrl3Bw